import React from 'react';
import PropTypes from 'prop-types';

import {AppContext} from '../../AppModule/Context';
import {withExpertHomeContext} from '../../screens/ExpertHome/ExpertHomeContextProvider';

import EmailInputComponent from '../common/genericComponents/redesign/emailInputComponent/emailInputComponent';
import FormComponentV2 from '../common/genericComponents/redesign/formComponentV2/formComponentV2';
import InputComponentV2 from '../common/genericComponents/redesign/inputComponentV2/inputComponentV2';
import LoaderComponent from '../common/genericComponents/redesign/loaderComponent/loaderComponent';
import MultiStateButton from '../common/genericComponents/redesign/multiStateButton/multiStateButton';
import NotificationComponent from '../common/genericComponents/notificationComponent';
import SeparatorComponent from '../common/genericComponents/separatorComponent/separatorComponent';
import VideoPlayerComponent from './videoPlayerComponent';

import callRecordingService from '../../services/restServices/callRecordingService';
import expertHomeService from '../../services/expertHomeService';
import userService from '../../services/restServices/userService';
import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';
import CopyIcon from '../../assets/svgComponents/LeftNavigationIcons/CopyIcon';
import ConsoltoLogo from '../../assets/svg/consolto-logo.svg';
import Deleted from '../../assets/svg/deleted.svg';
import Pause from '../../assets/svg/pause.svg';
import Warning from '../../assets/svg/warning.svg';

import './videoMessageComponentWrapper.css';
import {ListeningRoomService} from '../../services/websocketService';
class VideoMessageComponentWrapper extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      callRecordingId: null,
      intervalCounter: 0,
      savingStatus: '', // RECORDING | SAVING | CANCELED |
      videoPlayerURL: '',
      shareLink: '',
      showCopyLinkModal: false,
      iconsMap: {
        DELETED: Deleted,
        RECORDING: Pause,
        SAVING: ConsoltoLogo,
        CANCELLED: Warning,
      },
      sendEmailForm: {
        emails: {
          value: [],
          isValid: false,
        },
        subject: {
          value: '',
          isValid: false,
        },
        comment: {
          value: '',
          isValid: true,
        },
      },
      callRecordingCreatedDate: '',
      showSendEmailPopup: false,
      notificationType: null,
      notificationTxt: '',
      showNotificationPopup: false,
      isSendBtnClicked: false,
      showEmailSpinner: false,
      showShakeAnim: false,
    };
    // this.pollingInterval = null;
  }
  async componentDidMount() {
    this.initSendEmailForm();
    this.updateVideoMsgWidgetId();
    await this.parseMetaData();
    this.registerListeners();
    this.fetchCallRecordingDto();
    // await this.startPolling();
  }
  componentWillUnmount = () => {
    // clearInterval(this.pollingInterval);
    this.unmounted = true;
    this.deleteDoWhenMessageReceivedFromListeningRoom();
  };

  updateVideoMsgWidgetId = () => {
    const videoMsgWidgetId =
      this.props.chatRoomDto.ownerObjectType ===
      VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR
        ? expertHomeService.getWidgetDtoByMentorId(
            this.props.expertHomeContext.widgetDtos,
            this.props.chatRoomDto.ownerObjectId,
          ).widgetId
        : expertHomeService.getWidgetDtoByTeamMentorId(
            this.props.expertHomeContext.widgetDtos,
            this.props.chatRoomDto.ownerObjectId,
          );
    this.setState({videoMsgWidgetId});
  };

  registerListeners = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom(
        async (data) => {
          if (
            data.messageType ===
              VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT_NO_SAVE &&
            data.content.SubType ===
              VIDABOO_CONSTANTS.CHAT_NO_SAVE_SUBTYPES.VIDEO_RECORDING_UPDATE &&
            data.content.callRecordingDto.callRecordingId ===
              this.state.callRecordingId
          ) {
            console.debug('MEETING_ROOM_CHAT: ', data);
            const callRecordingDto = data.content.callRecordingDto;
            if (callRecordingDto?.savingState)
              this.setState({savingStatus: callRecordingDto?.savingState});
            if (callRecordingDto.savingState === 'READY') {
              this.deleteDoWhenMessageReceivedFromListeningRoom();
              this.setState({
                videoPlayerURL: callRecordingDto.tempAccessibleStreamUrl,
                videPlayerPosterUrl:
                  callRecordingDto.tempAccessibleThumbnailUrl,
                callRecordingCreatedDate: callRecordingDto.serverCreationTime,
              });
            } else if (
              callRecordingDto.savingState === 'CANCELLED' ||
              callRecordingDto.savingState === 'DELETED'
            ) {
              this.deleteDoWhenMessageReceivedFromListeningRoom();

              // clearInterval(this.pollingInterval);
            }
          }
        },
      );
  };

  initSendEmailForm = () => {
    const {sendEmailForm} = this.state;
    const {peerEmail} = this.props;
    const displayName = this.getDisplayName();
    sendEmailForm.emails.value = peerEmail
      ? [{email: peerEmail, isValid: true}]
      : [];
    sendEmailForm.emails.isValid = peerEmail
      ? this.validateEmails(sendEmailForm['emails'].value)
      : false;
    sendEmailForm.subject.value = `Link to our recorded conversation: ${displayName}`;
    sendEmailForm.subject.isValid = true;
    this.setState({
      sendEmailForm,
      isSendBtnClicked: false,
      showEmailSpinner: false,
      showShakeAnim: false,
    });
  };

  getDisplayName = () => {
    return (
      expertHomeService.getWidgetNameExMentorDtoUsingMentorId(
        this.props.expertHomeContext.widgetDtos,
        this.props.chatRoomDto.ownerObjectId, // todo 1938: add widgetId solution here.
      )?.extendedMentorDto?.mentorDto?.displayName ??
      expertHomeService.getSelectedMentorDto(
        this.props.expertHomeContext.selectedMentorDtos,
      ).displayName
    );
  };

  // startPolling = async () => {
  //   // when we'll add the direct connection from backend to websocket --> this is where it will trigger the fetching of the updated call recording
  //   this.fetchCallRecordingDto();
  //   this.pollingInterval = setInterval(() => {
  //     this.setState({intervalCounter: this.state.intervalCounter + 1});
  //     if (this.state.intervalCounter >= 10) {
  //       clearInterval(this.pollingInterval);
  //     }
  //     this.fetchCallRecordingDto();
  //   }, 10000);
  // };

  fetchCallRecordingDto = async () => {
    const callRecordingDto =
      await callRecordingService.getCallRecordingByCallRecordingId(
        this.state.callRecordingId,
      );
    if (this.unmounted) return;
    if (callRecordingDto) {
      this.setState({savingStatus: callRecordingDto.savingState});
      if (callRecordingDto.savingState === 'READY') {
        this.deleteDoWhenMessageReceivedFromListeningRoom();

        // clearInterval(this.pollingInterval);
        this.setState({
          videoPlayerURL: callRecordingDto.tempAccessibleStreamUrl,
          videPlayerPosterUrl: callRecordingDto.tempAccessibleThumbnailUrl,
          callRecordingCreatedDate: callRecordingDto.serverCreationTime,
        });
      } else if (
        callRecordingDto.savingState === 'CANCELLED' ||
        callRecordingDto.savingState === 'DELETED'
      ) {
        this.deleteDoWhenMessageReceivedFromListeningRoom();

        // clearInterval(this.pollingInterval);
      }
    } else {
      //todo: handle error with notification
      console.debug(
        'Error in fetching call-recording: ' + this.state.callRecordingId,
      );
    }
  };
  parseMetaData = async () => {
    try {
      const parsedMeta = JSON.parse(this.props.chatMessageDto.metaData);
      this.setState({callRecordingId: parsedMeta.callRecordingId});
    } catch (error) {
      console.debug('Error in parsing call recording meta');
    }
  };
  updateShareLink = (shareLink) => {
    this.setState({showCopyLinkModal: true, shareLink});
  };

  handleCopyClick = () => {
    utilsService.copyTextToClipboard(this.state.shareLink);
    const toastObj = utilsService.getToastObj({
      toastTitle: 'Copied',
    });
    this.context.addToastObj(toastObj);
  };

  closeModal = () => {
    this.setState({showCopyLinkModal: false});
  };

  setSavingStatus = (savingStatus) => {
    this.setState({savingStatus});
  };
  handleChange = (id, value, areAllEmailsValid) => {
    const sendEmailForm = {...this.state.sendEmailForm};
    switch (id) {
      case 'emails':
        sendEmailForm['emails'].value = value;
        sendEmailForm['emails'].isValid = areAllEmailsValid;
        break;
      case 'subject':
        sendEmailForm['subject'].value = value;
        sendEmailForm['subject'].isValid = !!value;
        break;
      case 'comment':
        sendEmailForm['comment'].value = value;
        sendEmailForm['comment'].isValid = true;
        break;
    }
    this.setState({sendEmailForm});
  };
  validateEmails = (emails) => {
    let isValid = true;
    emails.forEach((emailObj) => {
      isValid =
        isValid &&
        VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(emailObj.email);
    });
    return isValid;
  };
  sendEmail = async () => {
    const {sendEmailForm} = this.state;
    this.setState({isSendBtnClicked: true});
    let isSendEmailFormValid = true;
    for (let key in sendEmailForm) {
      isSendEmailFormValid = isSendEmailFormValid && sendEmailForm[key].isValid;
    }
    if (isSendEmailFormValid) {
      this.setState({showEmailSpinner: true});
      const requestData = {
        chatMessageId: this.props.chatMessageDto.chatMessageId,
        emails: sendEmailForm.emails.value.map((emailObj) => emailObj.email),
        content: sendEmailForm.comment.value,
        subject: sendEmailForm.subject.value,
        userIds: [],
      };
      for (const userEmail of requestData.emails) {
        const newUserObj = {
          email: userEmail,
          timezone: this.context.currentUser.scheduleSettings?.timezone,
        };
        userService.createEmailUser(
          newUserObj,
          async (response) => {
            if (response) {
              requestData.userIds.push(response.userDto.userId);
              if (requestData.userIds.length === requestData.emails?.length) {
                const responseData =
                  await callRecordingService.sendCallRecordingLinkByEmail(
                    requestData,
                  );
                if (responseData?.status === 'SUCCESS') {
                  this.setState({
                    notificationType:
                      VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.LIGHT,
                    notificationTxt:
                      'The call recording link was sent successfully',
                  });
                } else {
                  this.setState({
                    notificationType:
                      VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
                    notificationTxt:
                      'Oh no.. there seems to be a problem somewhere in the internet. Contact us at support@consolto.com',
                  });
                }
                this.setState({
                  showNotificationPopup: true,
                });
                this.closeSendEmailPopup();
              }
            }
          },
          () => {
            this.setState({showEmailSpinner: false});
          },
        );
      }
    } else {
      this.setState({showShakeAnim: true});
    }
  };
  getHumanReadableDate = (date) =>
    date && date !== ''
      ? `${new Date(date).toLocaleDateString()}, ${new Date(
          date,
        ).toTimeString()}`
      : '...';

  showSendEmailPopup = () => {
    this.setState((state) => ({showSendEmailPopup: !state.showSendEmailPopup}));
  };
  closeSendEmailPopup = () => {
    this.setState({showSendEmailPopup: false});
    this.initSendEmailForm();
  };
  render() {
    const {
      showCopyLinkModal,
      shareLink,
      callRecordingCreatedDate,
      showSendEmailPopup,
      sendEmailForm,
      isSendBtnClicked,
      showShakeAnim,
      showEmailSpinner,
    } = this.state;

    return (
      <div className="et-video-message-component-wrapper">
        {this.state.showNotificationPopup && (
          <NotificationComponent
            notificationType={this.state.notificationType}
            notificationTxt={this.state.notificationTxt}
            closeBtnTxt={'OK'}
            closeBtnFunc={() => {
              this.setState({showNotificationPopup: false});
            }}
          />
        )}
        {this.state.savingStatus === 'READY' ? (
          <VideoPlayerComponent
            videoPlayerURL={this.state.videoPlayerURL}
            videPlayerPosterUrl={this.state.videPlayerPosterUrl}
            callRecordingId={this.state.callRecordingId}
            updateShareLink={this.updateShareLink}
            setSavingStatus={this.setSavingStatus}
            showSendEmailPopup={this.showSendEmailPopup}
            chatMessageDto={this.props.chatMessageDto}
            type={this.props.type}
            goToMessage={this.props.goToMessage}
            videoMsgWidgetId={this.state.videoMsgWidgetId}
          />
        ) : (
          <div className="et-video-message-component-status">
            {this.state.savingStatus === 'SAVING' ? (
              <LoaderComponent />
            ) : (
              <img
                src={this.state.iconsMap[this.state.savingStatus]}
                alt={this.state.iconsMap[this.state.savingStatus]}
              />
            )}
            <div className="et-video-message-component-status-message">
              {this.state.savingStatus === 'SAVING'
                ? 'PROCESSING'
                : this.state.savingStatus}
            </div>
          </div>
        )}

        {showCopyLinkModal && (
          <FormComponentV2
            showRightBtn={false}
            formTitle="Share video recording"
            leftBtnTxt="Close"
            onLeftBtnClicked={this.closeModal}>
            <SeparatorComponent />
            <div className="et-vmc-share-video-form-content-wrap">
              <InputComponentV2
                id="media_link"
                disabled
                hideCharacterCount
                defaultValue={shareLink}
              />
              <div className="et-v2-vmc-copy-icon-btn">
                <MultiStateButton
                  isPrimaryBtn
                  onClick={this.handleCopyClick}
                  rightImage={<CopyIcon />}
                />
              </div>
            </div>
            <SeparatorComponent />
          </FormComponentV2>
        )}
        {showSendEmailPopup && (
          <FormComponentV2
            isRightBtnDisabled={
              isSendBtnClicked &&
              (!sendEmailForm['emails'].isValid ||
                !sendEmailForm['subject'].isValid)
            }
            showShakeAnim={showShakeAnim}
            showRightBtnSpinner={showEmailSpinner}
            formTitle="Send an email"
            leftBtnTxt="Close"
            rightBtnTxt="Send"
            onLeftBtnClicked={this.closeSendEmailPopup}
            onRightBtnClicked={this.sendEmail}>
            <SeparatorComponent />
            <EmailInputComponent
              id="emails"
              showCustomError={
                isSendBtnClicked && !sendEmailForm['emails'].isValid
              }
              initialEmails={sendEmailForm['emails'].value}
              errorMessage="Please enter valid email(s)"
              placeholder="Enter email here"
              titleTxt="To:"
              onEmailsChanged={this.handleChange}
            />
            <SeparatorComponent />
            <InputComponentV2
              id="subject"
              noWaitOnInput={true}
              defaultValue={this.state.sendEmailForm.subject.value}
              errorMessage="Please provide valid subject"
              placeholder="Subject"
              titleTxt="Subject:"
              onChange={this.handleChange}
              showCustomError={
                isSendBtnClicked && !sendEmailForm['subject'].isValid
              }
            />
            <SeparatorComponent />
            <InputComponentV2
              id="comment"
              noWaitOnInput={true}
              defaultValue={this.state.sendEmailForm.comment.value}
              placeholder="Your comment here…"
              titleTxt="Content:"
              onChange={this.handleChange}
            />
            <SeparatorComponent />
            <div className="et-vmc-send-email-content-form-label-text">
              (The link will be valid for the next 3 days)
              <br /> Time of call:{' '}
              {this.getHumanReadableDate(callRecordingCreatedDate)}
              <br /> Best, <br />
              {this.getDisplayName()}
            </div>
            <SeparatorComponent />
          </FormComponentV2>
        )}
      </div>
    );
  }
}

VideoMessageComponentWrapper.propTypes = {
  chatMessageDto: PropTypes.object.isRequired,
};
VideoMessageComponentWrapper.contextType = AppContext;

export default withExpertHomeContext(VideoMessageComponentWrapper);
